import { useTranslation } from 'react-i18next'
import RadioInput from '../../../../ui/form/RadioInput'
import api from '../../../../api'
import type { ChannelConfig, CreateOptionsProps, CreateTemplateFn } from '../TemplateCreateModal'

const EmailCreateOptions = ({ form }: CreateOptionsProps) => {
    const { t } = useTranslation()
    return (
        <RadioInput.Field
            form={form}
            name="data.editor"
            label={t('editor_type')}
            options={[
                { key: 'bee', label: t('visual') },
                { key: 'code', label: t('code') },
            ]}
        />
    )
}

const emailCreateTemplate: CreateTemplateFn = async ({ campaign, data, clonedTemplate, initialData }) => {
    const needsConversion = data?.editor === 'bee'
        && initialData?.mjml
        && clonedTemplate?.data?.editor !== 'bee'

    if (needsConversion) {
        return {
            data: { ...initialData, editor: clonedTemplate?.data?.editor ?? 'visual' },
            postCreate: async (template) => {
                try {
                    return await api.templates.convert(campaign.project_id, template.id)
                } catch {
                    return template
                }
            },
        }
    }

    return { data: initialData }
}

export const emailChannel: ChannelConfig = {
    CreateOptions: EmailCreateOptions,
    createTemplate: emailCreateTemplate,
}
